import React from 'react';
import gvMark from '../assets/logo-vilarouca-simbolo-branco.svg';

// Formas suaves como pano de fundo, com a logomarca oficial do Grupo
// Vilarouca centralizada por cima.
function HeroIllustration() {
  return (
    <div className="hero-illustration">
      <svg viewBox="0 0 420 420" className="hero-illustration__bg" aria-hidden="true">
        <circle cx="150" cy="150" r="150" fill="var(--teal-pale)" opacity="0.7" />
        <circle cx="300" cy="270" r="105" fill="var(--sand)" opacity="0.9" />
      </svg>
      <img src={gvMark} alt="Grupo Vilarouca" className="hero-illustration__mark" />
    </div>
  );
}

export default HeroIllustration;
